export enum PPLSyncStatus {
  AlreadyInSync = 'already_in_sync',
  NeedsDecision = 'needs_decision',
  SuccessUpdatedExternal = 'success_updated_external',
  SuccessUpdatedLocal = 'success_updated_local',
  ValidationError = 'sync_validation_error',
}
